import { MouseEventHandler } from "react";
import styled from "styled-components";

type ImageProps = {
  width?: number | string;
  margin?: number | string;
  showCursorPointer?: boolean;
  borderRadius?: string;
  position?: string;
  bottom?: string;
  right?: string;
  zIndex?: number;
};

export const ImageTagStyle = styled.img<ImageProps>`
  display: inline-block;
  margin: ${(props: any) => props.margin};
  width: ${(props: any) => props.width};
  position: ${(props: any) => props.position};
  right: ${(props: any) => props.right};
  z-index: ${(props: any) => props.zIndex};
  bottom: ${(props: any) => props.bottom};

  border-radius: ${(props: any) =>
    props?.borderRadius ? props.borderRadius : "unset"};
  flex-shrink: 0;
  ${(props) => props.showCursorPointer && ` cursor: pointer;`}
`;
